import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '='
    },
    template: `
        <a ng-if="!vm.isArchived" class="btn ico-globe type02" ng-click="vm.manageLanguages()">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor (ModalService, CourseResource, $scope, TokenService) {
        this.ModalService = ModalService;
        this.CourseResource = CourseResource;
        this.isArchived = this.course.isArchived;
        this.TokenService = TokenService;

        $scope.$on('archiveChange', (event, { isArchived }) => {
            this.isArchived = isArchived;
        });
    }

    manageLanguages () {
        const { course } = this;
        const companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        let modalWidth = 'xlarge';
        if (companySupportedLanguages && companySupportedLanguages.length > 4) {
            modalWidth = 'full';
        }
        this.CourseResource.get({ id: course.id, expand:
            'fields,courseFields,courseTrainings,courseTrainingsActiveI18n,activeI18n,courseI18ns,courseTrainingI18ns,courseVersions'
            + ',courseTrainingForms, sites, courseVersions.courseTrainings.courseTrainingI18ns,courseVersions.courseTrainings.materials'
            + ',courseVersions.courseTrainings.materials.languages,courseVersions.courseTrainings.materials.chapters.chapterI18ns'
            + ',courseVersions.courseTrainings.materials.chapters.section.sectionI18ns,courseVersions.courseTrainings.scormTrainings,'
            + 'courseVersions.courseTrainings.forms' }).$promise.then((updatedCourse) => {
                return this.ModalService.open({
                    animation: true,
                    template: `
                    <modals-courses-translation course="vm.course" cancel="vm.$uibModalInstance.dismiss()"
                        class="wrapper"></modals-courses-translation>
                    `,
                    size: modalWidth,
                    controller ($uibModalInstance, CourseResource) {
                        this.$uibModalInstance = $uibModalInstance;
                        this.course = updatedCourse;
                        this.CourseResource = CourseResource;
                    }
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/translation/index.js